export enum InformationBoxStyle {
	ROUNDED,
	SQUARE
}
